<template lang="pug">
v-container(fluid pa-0 ma-0)
  editor(
    :api-key="apiKey"
    @onChange="emitInput"
    @onKeyDown="emitInput"
    v-model="content"
    :init="init"
    ref="editor"
  )
</template>
<script>
export default {
  props: {
    page: {
      type: Object,
      default: null,
    },
    gallery: {
      type: Object,
      default: null,
    },
    placement: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: '500px',
    },
  },
  data() {
    return {
      key: 1,
      content: '',
      existingWidget: false,
      widget: {
        placement: this.placement,
        content: this.content,
      },
      apiKey: process.env.VUE_APP_TINYMCE_API_KEY,
      init: {
        height: this.height,
        branding: false,
        menubar: false,
        statusbar: false,
        selector: 'textarea',
        automatic_uploads: true,
        images_reuse_filename: true,
        block_unsupported_drop: true,
        paste_data_images: true,
        file_picker_types: 'image',
        images_upload_base_path: 'https://files.kubiqa.com/',
        images_upload_handler: this.uploadImage,
        plugins: 'table, media, image',
        toolbar:
          'undo redo | fontselect | fontsizeselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | image ',
      },
    };
  },
  mounted() {
    this.existingWidget = this.lodash.find(this.page.widgets, { placement: this.placement });
    if (this.existingWidget) {
      this.content = this.existingWidget.content;
      this.widget = this.existingWidget;
    }
    this.key++;
  },
  methods: {
    emitInput() {
      this.$emit('input', this.content);
    },
    uploadImages() {
      return this.$refs.editor.editor.uploadImages();
    },
    async uploadImage(blobInfo, success, failure) {
      const data = new FormData();
      data.append('gallery_id', this.gallery.id);
      data.append('file', blobInfo.blob());
      return this.$store
        .dispatch('galleries/addImage', data)
        .then((response) => success(this.path(response.path)))
        .catch((error) => failure(error));
    },
    async save() {
      this.$emit('loading', true);
      try {
        await this.$refs.editor.editor.uploadImages();
        this.widget.content = this.content;
        if (!this.existingWidget) {
          this.widget.page_id = this.page.id;
          await this.$store.dispatch('website/addWidget', this.widget);
        } else {
          this.widget.id = this.existingWidget.id;
          await this.$store.dispatch('website/updateWidget', this.widget);
        }
        this.close();
      } catch (error) {
        this.$store.commit('SET_ERROR', error);
        this.$emit('loading', false);
      }
    },
    close() {
      this.$emit('close');
      this.$emit('loading', false);
    },
  },
};
</script>
<style>
.tox-edit-area__iframe {
  background: #f3f3f3 !important;
}
</style>
